import { render, staticRenderFns } from "./RequestDemo.vue?vue&type=template&id=270c8678&scoped=true&"
import script from "./RequestDemo.vue?vue&type=script&lang=js&"
export * from "./RequestDemo.vue?vue&type=script&lang=js&"
import style0 from "./RequestDemo.vue?vue&type=style&index=0&id=270c8678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c8678",
  null
  
)

export default component.exports